module.exports = __webpack_public_path__ + "static/media/pyramid.65ccab99.png";